import React from 'react';
import BaseClass from '@/pages/BaseClass';

import $ from 'jquery';
import moment from 'moment';
import {
	Form,
	Table,
	Button,
	Input,
	Modal,
	Select,
	DatePicker,
} from 'antd'
import {
	CommonValue,
	ngUrl,
	pcUrl,
	confirm,
	message,
	notify,
	parseTime,
	httpPost
} from '@/utils/Tools';

const {Column,ColumnGroup} = Table;
const {Option} = Select;
export default class App extends BaseClass
{
	constructor(props)
	{
		super(props);
		
		this.state={
			'list':[],
			'showDialog':false,
			'pageInfo':{
				'current':1,
				'total':100,
				'pageSize':10,
			},
		};
	}
	
	componentDidMount()
	{
		this.getList();
		document.title = '账户明细 - ' + CommonValue.get('site_name');
	}
	
	getList(page,pageSize)
	{
		if(!page) page = 1;
		if(!pageSize) pageSize = this.state.pageInfo.pageSize;
		
		let url = pcUrl('moneyLog','index');
		let param = this._parseFilter(this.filterForm.getFieldsValue());
		param['page'] = page;
		param['page_size'] = pageSize;
		
		httpPost(url,param)
			.then(data=>{
				this.setState({
					'list':data['list'],
					'pageInfo':{
						'current':page,
						'total':data['page_info'].total,
						'pageSize':pageSize,
					},
				});
			});
	}
	_parseFilter(filter)
	{
		if(filter.time && filter.time.length)
		{
			filter['start_time'] = moment(filter.time[0]).format('YYYY-MM-DD');
			filter['end_time'] = moment(filter.time[1]).format('YYYY-MM-DD');
			delete(filter.time);
		}
		return filter;
	}
	
	add()
	{
		this.setState({
			'showDialog':true,
		});
	}
	
	render()
	{
		return (
			<div>
				<div className="user-panel">
					<div className="captain">
						<h3>资金记录</h3>
					</div>
					<div className="panel-body">
						<div className="filter">
							<Form layout="inline" ref={e=>this.filterForm=e} onFinish={(data)=>this.getList()}>
								<Form.Item name="time">
									<DatePicker.RangePicker />
								</Form.Item>
								<Form.Item name="type">
									<Select allowClear placeholder="选择资金类型" style={{'width':'12em'}}>
										<Option value={0}>收入</Option>
										<Option value={1}>支出</Option>
									</Select>
								</Form.Item>
								<Form.Item name="remark">
									<Input allowClear={true} style={{'width':'12em'}} placeholder="备注" />
								</Form.Item>
								<Form.Item name="">
									<button className="button button-green">
										<span className="fa fa-search"></span>
										&nbsp;
										搜索
									</button>
								</Form.Item>
							</Form>
						</div>
						<Table pagination={{...this.state.pageInfo,'onChange':(page)=>this.getList(page)}} dataSource={this.state.list}>
							<Column title="金额" dataIndex="amount" />
							<Column title="类型" align="center" dataIndex="type" render={(text,row,index)=>+row.type ? '支出':'收入'} />
							<Column title="备注" dataIndex="remark" />
							<Column title="时间" dataIndex="add_time" render={(text,row,index)=>parseTime(row.add_time)} />
						</Table>
					</div>
				</div>
			</div>
		);
	}
}


